import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { MaterialModule } from '@material/material.module';
import { SharedModule } from '@shared/shared.module';
import { ContactDialogComponent } from '@widgets/navigation/contact-dialog/contact-dialog.component';
import { ImprintComponent } from '@widgets/navigation/imprint/imprint.component';
import { ImprintDialogComponent } from '@widgets/navigation/imprint-dialog/imprint-dialog.component';
import { SideMenuButtonComponent } from '@widgets/navigation/side-menu/side-menu-button/side-menu-button.component';
import { SideMenuComponent } from '@widgets/navigation/side-menu/side-menu.component';
import { ToolbarComponent } from '@widgets/navigation/toolbar/toolbar.component';

@NgModule({
  declarations: [
    ContactDialogComponent,
    SideMenuComponent,
    SideMenuButtonComponent,
    ImprintDialogComponent,
    ImprintComponent,
    ToolbarComponent,
  ],
  imports: [CommonModule, TranslateModule.forChild(), SharedModule, MaterialModule, RouterModule],
  exports: [SideMenuComponent, ToolbarComponent, ImprintComponent],
})
export class NavigationModule {}
